import { z } from 'zod';
/** Engagement lifecycle stages. Transitions are enforced in apps/backend domain code, never by an LLM. */
export const EngagementStageSchema = z.enum([
    'DRAFT',
    'SCOPE_PENDING_APPROVAL',
    'SCOPED',
    'DISCOVERY',
    'PASSIVE',
    'PLAN_PENDING_APPROVAL',
    'ACTIVE',
    'TRIAGE',
    'REPORT_PENDING_APPROVAL',
    'PUBLISHED',
    'CANCELLED',
    'FAILED',
]);
/** Whitelisted transitions. Anything not listed here is rejected. */
export const ENGAGEMENT_TRANSITIONS = {
    DRAFT: ['SCOPE_PENDING_APPROVAL', 'CANCELLED'],
    SCOPE_PENDING_APPROVAL: ['SCOPED', 'DRAFT', 'CANCELLED'],
    SCOPED: ['DISCOVERY', 'CANCELLED'],
    DISCOVERY: ['PASSIVE', 'FAILED', 'CANCELLED'],
    PASSIVE: ['PLAN_PENDING_APPROVAL', 'TRIAGE', 'FAILED', 'CANCELLED'],
    PLAN_PENDING_APPROVAL: ['ACTIVE', 'TRIAGE', 'CANCELLED'],
    ACTIVE: ['TRIAGE', 'FAILED', 'CANCELLED'],
    TRIAGE: ['REPORT_PENDING_APPROVAL', 'FAILED', 'CANCELLED'],
    REPORT_PENDING_APPROVAL: ['PUBLISHED', 'TRIAGE', 'CANCELLED'],
    PUBLISHED: [],
    CANCELLED: [],
    FAILED: [],
};
/** Stages whose exit requires a recorded human approval. */
export const APPROVAL_GATES = new Set([
    'SCOPE_PENDING_APPROVAL',
    'PLAN_PENDING_APPROVAL',
    'REPORT_PENDING_APPROVAL',
]);
export function canTransition(from, to) {
    return ENGAGEMENT_TRANSITIONS[from].includes(to);
}
//# sourceMappingURL=engagement.js.map